import { useSelector } from 'react-redux';

import { EnvironmentFactory } from 'StorytellerEnvironment';
import { selectors as storySelectors } from 'store/selectors/StorySelectors';
import type { StorytellerState } from 'store/StorytellerReduxState';

/**
 * The layout of the story currently in the environment, or null if there isn't one.
 *
 * Rich text editors need this alongside the theme to style their content, and every
 * consumer wants the current story, so it is read here rather than threaded through props.
 */
export function useStoryLayout() {
  const storyUid = EnvironmentFactory().STORY_UID;

  return useSelector((state: StorytellerState) =>
    storyUid ? storySelectors.getStoryLayout(state, storyUid) : null,
  );
}
